import { SbBlokData, storyblokEditable } from '@storyblok/react'

/**
 * Helper function to make Storyblok generated types compatible with storyblokEditable.
 * 
 * The generated types use `[k: string]: unknown` while SbBlokData expects
 * `[index: string]: SbBlokKeyDataTypes`. This helper safely bridges the gap.
 * 
 * @param blok - Any Storyblok component type
 * @returns The props object from storyblokEditable
 */
export function editable<T extends { _uid: string; component: string; [k: string]: unknown }>(
  blok: T
): ReturnType<typeof storyblokEditable> {
  return storyblokEditable(blok as unknown as SbBlokData)
}
